export const BRAND = {
  name: "MiCells",
  email: "info@micells.io",
  logoMark: "/brand/logo-mark.png",
  logoWordmark: "/brand/logo-wordmark.png",
  wordmarkWhite: "/brand/wordmark-white.png",
  wordmarkDark: "/brand/wordmark-dark.png",
  heroVideo: "/brand/hero.mp4",
  links: {
    linkedin: "https://hk.linkedin.com/company/micells",
    x: "https://x.com/mi_cells",
  },
};

export const NAV = [
  { label: "Framework", href: "#framework" },
  { label: "Process", href: "#process" },
  { label: "Advisory", href: "#advisory" },
  { label: "Insights", href: "#insights" },
  { label: "Partners", href: "#investors" },
];
